import React from 'react';

export const path =
  'M1.88050747,8.25011388 L6.99399838,13.0034998 L12.1074893,8.26211738 C12.1795103,8.20209988 13.8600003,6.6656519 13.8600003,4.81711294 C13.8600003,2.58446197 12.4916013,1.24007 10.1989328,1.24007 C8.85454085,1.24007 7.60617687,2.29637798 6.99399838,2.89655297 C6.39382339,2.29637798 5.13345592,1.24007 3.80106744,1.24007 C1.50839898,1.24007 0.140000001,2.58446197 0.140000001,4.81711294 C0.140000001,6.6656519 1.82048997,8.20209988 1.88050747,8.25011388 Z';

export default class Heart extends React.PureComponent {
  render() {
    return <path d={path} className="fill-current" />;
  }
}
